import makeStyles from 'd2/hooks/tss/makeStyles'
import type { MergedThemes } from 'd2/types'

const styles = (theme: MergedThemes) => ({
  withTopBorder: {
    borderTop: `1px solid ${theme.branding?.lightestGrayBorder ?? 'transparent'}`,
  },
} as const)
export default makeStyles({
  name: 'MetadataBox',
})(styles)
